module.exports = __webpack_public_path__ + "img/video.36df9753.png";